export { default as PropietariosListar } from './Listar'
export { default as PropietarioCrear } from './Crear'
